module.exports = __webpack_public_path__ + "static/MTBLists_IL_Spacing-d42101ec5dbec13549b28f77ad286d52.png";